import type { LabsGqlCreateOrderHoldMutationVariables } from '@orthly/graphql-operations';
import { useCreateOrderHoldMutation } from '@orthly/graphql-react';
import { useChangeSubmissionFn } from '@orthly/ui';

type CreateOrderHoldVars = LabsGqlCreateOrderHoldMutationVariables['data'];

export const useCreateOrderHold = (onSuccess: () => void) => {
    const [submitCreateHoldMtn] = useCreateOrderHoldMutation();
    const createHoldMtnSubmitter = (data: CreateOrderHoldVars) => submitCreateHoldMtn({ variables: { data } });
    return useChangeSubmissionFn<any, [CreateOrderHoldVars]>(createHoldMtnSubmitter, {
        successMessage: () => ['This order will be paused for the next 45 days or until you resume the order.'],
        onSuccess,
    });
};
